import { NavLink } from "react-router-dom";
import newsdata from "../../News.json";
import { useEffect, useState } from "react";
import RandomProducts from "../Shop/RandomProducts";
import back from "../../images/widget-background.webp";

const NewsHero = () => {
  const [productData, setProductData] = useState([]);
  useEffect(() => {
    fetch("products.json")
      .then((res) => res.json())
      .then((data) => setProductData(data));
  }, []);
  return (
    <div className="flex items-start gap-8 py-[50px] px-[30px]">
      <div className="w-[100%] lg:w-[70%] bg-white">
        {newsdata.map((news) => (
          <div
            key={news.id}
            className="flex flex-col lg:flex-row items-center gap-8 py-[20px] px-[10px] border-b-[1px] border-dashed border-gray-300"
          >
            <div className="h-[220px] w-[350px] lg:w-[750px] bg-red-500 overflow-hidden rounded-[10px]">
              <NavLink to={`/${news.id}`}>
                <img
                  src={news.image}
                  alt=""
                  className="h-[100%] w-[100%] rounded-[10px] hover:scale-[1.1] transition-all ease-in-out duration-700"
                />
              </NavLink>
            </div>
            <div className="flex flex-col gap-5">
              <NavLink to={`/${news.id}`}>
                <span className="py-[4px] px-[7px] bg-black text-white font-[600] text-[12px] rounded-[5px] hover:bg-amber-500 hover:text-black">
                  {news.category}
                </span>
              </NavLink>
              <h3 className="font-[700] text-[20px]">
                <NavLink to={`/${news.id}`} className="hover:text-amber-500">
                  {news.title}
                </NavLink>
              </h3>
              <p className="text-[18px]">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Voluptatem sint itaque, exercitationem neque quis dolorem, alias
                fugiat placeat enim fugit quaerat autem.....
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="w-[30%] hidden lg:flex flex-col bg-white py-[50px]">
        <div
          id="widget"
          className="flex flex-col justify-between rounded-[20px]"
        >
          <div className="text-left pl-[40px]">
            <p className="font-[600] text-[18px]">NEW COLLECTION</p>
            <h3 className="text-[55px] font-[600]">40%</h3>
          </div>
          <button className="relative left-[50%] translate-x-[-50%] rounded-[5px] bg-black text-white w-[60%] py-[10px] px-[10px] hover:bg-amber-500 hover:text-black">
            VIEW MORE
          </button>
        </div>

        <RandomProducts products={productData} back={back} />
      </div>
    </div>
  );
};

export default NewsHero;
